__turbopack_context__.v({
  "root": "PlasmicSliderThumb-module__TqqIea__root",
  "rootglobal_themeOrange_override": "PlasmicSliderThumb-module__TqqIea__rootglobal_themeOrange_override",
});
